import React from 'react';

import './Logo.style.scss';

export default function Logo() {
  return (
    <div className="logo">
      <span className="logo__img" />
      <span className="logo__text header-font">SHOESHOE</span>
    </div>
  );
}
